import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { DataGrid, GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import { FC } from "react";

const PAGE_SIZE = 10;

interface Props {
  companies: CompanyDTO[];
  totalElements: number;
  loading: boolean;
  paginationModel: GridPaginationModel;
  ownCompanyId?: string;

  // eslint-disable-next-line no-unused-vars
  onPaginationModelChange: (model: GridPaginationModel) => void;

  // eslint-disable-next-line no-unused-vars
  onRowClick: (company: CompanyDTO) => void;

  // eslint-disable-next-line no-unused-vars
  onDeleteClick: (company: CompanyDTO) => void;
}

const CompanyTable: FC<Props> = ({
  companies,
  totalElements,
  loading,
  paginationModel,
  ownCompanyId,
  onPaginationModelChange,
  onRowClick,
  onDeleteClick,
}) => {
  const columns: GridColDef<CompanyDTO>[] = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    { field: "name", headerName: "Nom", flex: 2, sortable: false },
    {
      field: "actions",
      headerName: "",
      width: 60,
      sortable: false,
      renderCell: (params) =>
        params.row.id === ownCompanyId ? null : (
          <IconButton
            color="error"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick(params.row);
            }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        ),
    },
  ];

  return (
    <DataGrid
      rows={companies}
      columns={columns}
      rowCount={totalElements}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      pageSizeOptions={[PAGE_SIZE]}
      loading={loading}
      disableColumnFilter
      onRowClick={(params) => onRowClick(params.row)}
      sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
    />
  );
};

export default CompanyTable;
